import React, { useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import {
  getCategoryImgInfo,
  getCategoryLabels,
  setCategoryStatus,
  setScroll,
} from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import Nav from './Nav';
import styles from './WallpaperCategory.module.less';
import WallpaperCategoryNav from './WallpaperCategoryNav';

const selectWpCategoryLabels = createSelector(
  state => {
    return state.wallpaper && state.wallpaper;
  },
  info => info.labelList || [],
);

const selectWpCategoryImgInfo = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.categoryInfo;
  },
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);

// const selectScrollElHeight = createSelector(
//   state => state.layout,
//   layout => layout.scrollElHeight,
// );
export default function Category() {
  const [load, setLoad] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { action, search } = history;
  const [activeClass, setActiveClass] = useState('-1');
  const [classStatus, setClassStatus] = useState('collapse');
  const [activeTag, setActiveTag] = useState('-1');
  const [tagStatus, setTagStatus] = useState('collapse');
  const [activeColor, setActiveColor] = useState('-1');

  const classList = useSelector(selectWpCategoryLabels);
  const [tagList, setTagList] = useState([]);
  const [colorList, setColorList] = useState([]);
  const categoryImgInfo = useSelector(selectWpCategoryImgInfo);
  const logInfoData = useSelector(selectLogInfo);
  const scrollInfo = useSelector(selectScroll);
  // const scrollElHeight = useSelector(selectScrollElHeight);
  const [contentElHeight, setContentElHeight] = useState(0);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeColor}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            activeClass,
            activeTag,
            activeColor,
          },
        }),
      );
    };
  }, []);

  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'PUSH') {
      el.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    const el = document.getElementById('container_content');
    if (el.scrollTop > 0 && action === 'POP') {
      dispatch(
        setScroll({
          categoryScrollTop: 0,
        }),
      );
    }
  }, [categoryImgInfo]);
  /**
   * POP 滚动到之前位置
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.categoryScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.categoryScrollTop) {
        el.scrollTo(0, scrollInfo.categoryScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.categoryScrollTop);
      }
    }
  }, [contentElHeight]);

  const getScrollList = useCallback(
    pagenation => {
      dispatch(
        getCategoryImgInfo({
          ...categoryImgInfo.pagenation,
          ...pagenation,
        }),
      );
    },
    [categoryImgInfo],
  );
  useEffect(() => {
    // 返回页面并且存在滚动数据

    if (action === 'POP' && categoryImgInfo.list && categoryImgInfo.list.length > 0) {
      setActiveClass(categoryImgInfo.pagenation.classId);
      const classIndex = classList.findIndex(
        item => item.classifyId === categoryImgInfo.pagenation.classId,
      );

      setTagList(classList[classIndex] && classList[classIndex].tags);
      setActiveTag(categoryImgInfo.pagenation.tagId);
      const tagIndex =
        classList[classIndex] &&
        classList[classIndex].tags.findIndex(
          item => item.tagId === categoryImgInfo.pagenation.tagId,
        );
      setColorList(
        classList[classIndex] &&
          classList[classIndex].tags &&
          classList[classIndex].tags[tagIndex] &&
          classList[classIndex].tags[tagIndex].color,
      );
      setActiveColor(categoryImgInfo.pagenation.colorId);
      setClassStatus(categoryImgInfo.status.classStatus);
      setTagStatus(categoryImgInfo.status.tagStatus);
    } else {
      dispatch(getCategoryLabels());
    }
  }, []);

  const handleClass = useCallback(
    classifyId => () => {
      if (classifyId !== activeClass) {
        setActiveClass(classifyId);
        const tagLists = classList.find(item => item.classifyId === classifyId).tags || [];
        const colorLists = (tagLists[0] && tagLists[0].color) || [];
        setTagList(tagLists);
        setColorList(colorLists);
        setActiveTag(tagLists[0] && tagLists[0].tagId);
        setActiveColor(colorLists[0] && colorLists[0].colorId);
        getScrollList({
          classId: classifyId,
          tagId: tagLists[0] && tagLists[0].tagId,
          colorId: colorLists[0] && colorLists[0].colorId,
          skip: 0,
          refresh: true,
        });
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${classifyId}||${tagLists[0] &&
                tagLists[0].tagId}||${colorLists[0] && colorLists[0].colorId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [activeClass, classList],
  );
  useEffect(() => {
    if (classList[0] && action === 'PUSH') {
      const classId = getQueryString('classId', search) || '-1';
      const tagId = getQueryString('tagId', search) || '-1';
      const colorId = getQueryString('colorId', search) || '-1';
      setActiveClass(classId);
      if (classList.findIndex(item => item.classifyId === classId) > 7) {
        setClassStatus('open');
        dispatch(
          setCategoryStatus({
            classStatus: 'open',
          }),
        );
      }
      setActiveTag(tagId);
      const tags = classList.find(item => item.classifyId === classId) || {};
      setTagList(tags.tags || []);
      if (tags.tags && tags.tags.findIndex(item => item.tagId === tagId) > 7) {
        setTagStatus('open');
        dispatch(
          setCategoryStatus({
            tagStatus: 'open',
          }),
        );
      }
      setActiveColor(colorId);
      const colors = (tags.tags && tags.tags.find(item => item.tagId === tagId)) || {};
      setColorList(colors.color || []);
      getScrollList({
        ...categoryImgInfo.pagenation,
        skip: 0,
        refresh: true,
        classId,
        tagId,
        colorId,
      });
      // history.replace(`${CONTEXT}/wpcategory`);
    } else if (
      // 本条件为为了排除测试代码时 ，刷新页面classList有数据但是action为pop
      classList[0] &&
      categoryImgInfo.pagenation.classId === '-1' &&
      categoryImgInfo.pagenation.tagId === '-1' &&
      categoryImgInfo.pagenation.colorId === '-1' &&
      action === 'POP'
    ) {
      const tagLists = classList.find(item => item.classifyId === '-1').tags || [];
      const colorLists = (tagLists[0] && tagLists[0].color) || [];
      setTagList(tagLists);
      setColorList(colorLists);
      if (!categoryImgInfo.list || categoryImgInfo.list.length === 0) {
        getScrollList({
          classId: '-1',
          tagId: '-1',
          colorId: '-1',
          skip: 0,
          refresh: true,
        });
      }
    }
  }, [classList]);

  const handleTag = useCallback(
    tagId => () => {
      if (activeTag !== tagId) {
        setActiveTag(tagId);
        const colorLists = tagList.find(item => item.tagId === tagId).color || [];
        setColorList(colorLists);
        setActiveColor(colorLists[0] && colorLists[0].colorId);
        getScrollList({
          tagId,
          colorId: colorLists[0] && colorLists[0].colorId,
          skip: 0,
          refresh: true,
        });
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${activeClass}||${tagId}||${colorLists[0] &&
                colorLists[0].colorId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [tagList, activeTag, activeClass, activeColor],
  );

  const handleColor = useCallback(
    colorId => () => {
      if (activeColor !== colorId) {
        setActiveColor(colorId);
        getScrollList({
          colorId,
          skip: 0,
          refresh: true,
        });
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'C_Wallpaper_Category_Tag',
            label: '',
            param2: {
              source: `Wallpaper_Category||${activeClass}||${activeTag}||${colorId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
      }
    },
    [activeColor, activeClass, activeTag],
  );

  useEffect(() => {
    if (load === null) {
      setLoad(true);
    } else {
      setLoad(false);
    }
  }, [categoryImgInfo]);

  useEffect(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Category',
        label: '',
        param2: {
          source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeColor}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );

    dispatch(
      logPostInfo({
        source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeColor}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    window.wpCateOpenPageTime = +new Date();
    loggingPVDuration();
  }, []);

  // 详情页面浏览时长打桩每隔30秒打一次，限制3分钟内
  const loggingPVDuration = useCallback(() => {
    const spaceTime = 30;
    setTimeout(() => {
      const diffTime = +new Date() - window.wpCateOpenPageTime;
      if (window.location.pathname.indexOf('wpcategory') > -1 && diffTime < 6 * spaceTime * 1000) {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'I_Wallpaper_Category_ViewTime',
            label: '',
            param2: {
              source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeColor}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              time: parseInt(diffTime / 1000, 10),
            },
          }),
        );
        loggingPVDuration();
      }
    }, spaceTime * 1000);
  }, [dispatch, activeClass, activeTag, activeColor]);

  // useEffect(() => {
  //   setContentElement(document.getElementById('container_content'));
  // }, [document.getElementById('container_content')]);

  const loadMore = useCallback(() => {
    if (!categoryImgInfo.load && categoryImgInfo.list.length < categoryImgInfo.pagenation.count) {
      const params = {
        ...categoryImgInfo.pagenation,
      };
      delete params.count;
      dispatch(
        getCategoryImgInfo({
          ...params,
          classId: activeClass,
          tagId: activeTag,
          colorId: activeColor,
          skip: categoryImgInfo.list.length,
          refresh: false,
        }),
      );
    }
  }, [categoryImgInfo, activeClass, activeTag, activeColor]);

  const getClassType = (index = 0) => {
    const pos = index % 3;
    if (pos === 1) {
      return 'small_center';
    }
    return 'small';
  };

  const handleMore = useCallback(
    (type, col) => () => {
      if (type === 'class') {
        setClassStatus(col ? 'collapse' : 'open');
        dispatch(setCategoryStatus({ classStatus: col ? 'collapse' : 'open', tagStatus }));
      } else {
        setTagStatus(col ? 'collapse' : 'open');
        dispatch(setCategoryStatus({ classStatus, tagStatus: col ? 'collapse' : 'open' }));
      }

      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Category_Tag',
          label: '',
          param2: {
            source: `Wallpaper_Category||${type === 'class' ? 'more' : activeClass}||${
              type !== 'class' ? 'more' : activeTag
            }||${activeColor}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    },
    [classStatus, tagStatus, activeClass, activeColor, activeTag],
  );
  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        categoryScrollTop: el && el.scrollTop,
      }),
    );
  };
  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  }, []);
  if ((load || load === null) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  return (
    <div className={styles.wp_content} onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      <Nav active="wpcategory" />
      <div className={styles.label}>
        <WallpaperCategoryNav
          list={classList}
          col={7}
          handleCategory={handleClass}
          status={classStatus}
          active={activeClass}
          text="分类"
          keyId="classifyId"
          keyName="classifyName"
          keyWord="class"
          handleMore={handleMore}
        />
        <WallpaperCategoryNav
          list={tagList}
          col={7}
          handleCategory={handleTag}
          status={tagStatus}
          active={activeTag}
          text="标签"
          keyId="tagId"
          keyName="tagName"
          keyWord="tag"
          handleMore={handleMore}
        />
        {/* <WallpaperCategoryNav
          list={colorList}
          col={10}
          handleCategory={handleColor}
          status="open"
          active={activeColor}
          text="色系"
          keyId="colorId"
          keyName="colorName"
          keyWord="color"
          handleMore={handleMore}
        /> */}
      </div>
      {categoryImgInfo.list.length > 0 && (
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={categoryImgInfo.list.length < categoryImgInfo.pagenation.count}
          loader={
            <div className="loader" key={0}>
              ----------加载中----------
            </div>
          }
          initialLoad={!categoryImgInfo.list.length}
          useWindow={false}
          getScrollParent={() => document.getElementById('container_content')}
        >
          <div className={styles.category}>
            {categoryImgInfo.list.map((item, index) => {
              return (
                <WallpaperCard
                  wallpaper={item}
                  key={index}
                  cardInfo={{
                    pageSource: 'category',
                    classId: activeClass,
                    tagId: activeTag,
                    colorId: activeColor,
                    classType: getClassType(index),
                    isCollect: true,
                    isWallpaper: true,
                    isDeleteColl: false,
                    isDeleteUsed: false,
                    isPreview: true,
                  }}
                  logInfo={{
                    source: `Wallpaper_Category||${activeClass}||${activeTag}||${activeColor}`,
                  }}
                />
              );
            })}
          </div>
          {categoryImgInfo.list.length >= categoryImgInfo.pagenation.count &&
            categoryImgInfo.pagenation.count > 12 && (
              <div className="loader">----------到底啦----------</div>
            )}
        </InfiniteScroll>
      )}
      {categoryImgInfo.pagenation.count < 1 && <Blank load={categoryImgInfo.load} more />}
      <ScrollTop />
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          background: '#fff',
          height: '25px',
          zIndex: '1001',
          width: '830px',
          left: '200px',
        }}
      />
    </div>
  );
}
